// =========================================
// Feature List — accordion (right-side video is static)
// =========================================
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.block-feature-list').forEach(function (block) {
        const items = Array.from(block.querySelectorAll('.block-feature-list__item'));
        if (!items.length) return;

        items.forEach(function (item, i) {
            const toggle = item.querySelector('.block-feature-list__toggle');
            if (!toggle) return;

            toggle.addEventListener('click', function () {
                items.forEach(function (el, j) {
                    const active = j === i;
                    el.classList.toggle('is-active', active);
                    const t = el.querySelector('.block-feature-list__toggle');
                    if (t) t.setAttribute('aria-expanded', active ? 'true' : 'false');
                    const ico = el.querySelector('.ico');
                    if (ico) {
                        ico.classList.toggle('ico-orange', active);
                        ico.classList.toggle('ico-navy', !active);
                    }
                });
            });
        });
    });
});
